import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../redux/store";
import {
  clearMyInfo,
  myInfoStateSelector,
  setMyInfo,
  setLoadingMyInfo,
} from "../redux/slices/auth/my-info.slice";
import { auth } from "../firebase";

export const useAuth = () => {
  const { error, loading, myInfo } = useAppSelector(myInfoStateSelector);
  const dispatch = useAppDispatch();

  const initialize = useCallback(() => {
    const unsubscribe = auth.onAuthStateChanged(
      async (user) => {
        dispatch(setMyInfo(user));
        dispatch(setLoadingMyInfo(false));
      },
      (error) => {
        console.error({ error });
        dispatch(clearMyInfo());
        dispatch(setLoadingMyInfo(false));
      }
    );
    return () => unsubscribe;
  }, [dispatch]);

  return {
    error,
    loading,
    myInfo,
    isAuthenticated: !!myInfo,
    initialize,
  };
};
